/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import liveSearchHelperData from "./data.js";
import liveSearchHelperLayout from "./layout.js";
import liveSearchHelperReset from "./reset.js";
import liveSearchHelperResponsive from "./responsive.js";

const liveSearchHelper = {
    ...liveSearchHelperData,
    ...liveSearchHelperLayout,
    ...liveSearchHelperReset,
    ...liveSearchHelperResponsive,
}

export default liveSearchHelper;
